import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { roleList } from "constants/role";

//get role list
export const getRoleListing = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_role_listing(pageNum, filters);
    dispatch({ type: roleList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: roleList,
      payload: error.response?.data ?? { message: error?.message },
    });
  }
};

//add role
export const addRole = async (bodyData) => {
  try {
    const res = await api.add_role(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

//edit role
export const editRole = async (id, bodyData) => {
  try {
    const res = await api.edit_role(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//get details
export const getRoleDetailsById = async (id) => {
  try {
    const res = await api.get_role_detail_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

//delete unit
export const deleteRole = async (id) => {
  try {
    const res = await api.delete_role_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};